/* eslint-disable */
import getRequest from 'utils/getRequest'
import { getApiUrl } from 'utils/apiBaseUrl'

const path = '/api/reports'
const monitoringPath = '/api/monitoring-reports'
export const getSitesReportsRequest = ({ queryString, pagination, sorting }) => {
  const url = sorting
    ? `${path}/sites?${queryString}&${pagination}&${sorting}`
    : `${path}/sites?${queryString}&${pagination}`
  return getRequest(url)
}

export const getSpeciesReportsRequest = ({ queryStrings, pagination, sorting }) => {
  return getRequest(`${path}/site-species?${queryStrings}&${pagination}&${sorting}`)
}

export const downloadSpeciesReports = () => {
  return getRequest(`${path}/site-species/download`)
}

export const getMonitoringSitesReportsRequest = ({ queryStrings, pagination, sorting }) => {
  const url = sorting
    ? `${monitoringPath}?${queryStrings}&${pagination}&${sorting}`
    : `${monitoringPath}?${queryStrings}&${pagination}`

  return getRequest(url)
}

const fetchDownloadChunks = async (url) => {
  const res = await fetch(url, { credentials: 'same-origin' })
  if (!res.ok) {
    return {
      error: res.statusText || `Request failed with status ${res.status}`,
      status: res.status
    }
  }
  if (!res.body) {
    return { error: 'Empty download response' }
  }
  return readAllChunks(res.body)
}

export const getMonitoringSitesForDownload = (queryStrings, sorting) => {
  const url = sorting
    ? `${monitoringPath}/download?${queryStrings}&${sorting}`
    : `${monitoringPath}/download?${queryStrings}`

  return fetchDownloadChunks(getApiUrl(url))
}

async function readAllChunks(readableStream) {
  const reader = readableStream.pipeThrough(new TextDecoderStream()).getReader()
  const chunks = []

  let done, value
  while (!done) {
    ;({ value, done } = await reader.read())
    if (done) {
      return chunks
    }
    chunks.push(value)
  }
}

export const downloadReportBlob = async (url) => {
  const fullUrl = getApiUrl(url)
  const res = await fetch(fullUrl, {
    method: 'GET',
    credentials: 'same-origin'
  })
  if (!res.ok) {
    return {
      error: res.statusText || `Request failed with status ${res.status}`,
      status: res.status
    }
  }
  const blob = await res.blob()
  return { blob }
}

export const downloadSpeciesReportFile = (queryString) => {
  return downloadReportBlob(`/api/reports/site-species/download?${queryString}`)
}

export const downloadSiteReportFile = (queryString) => {
  return downloadReportBlob(`/api/reports/sites/download?${queryString}`)
}

export const getSiteForDownload = (queryString) => {
  return fetchDownloadChunks(getApiUrl(`/api/reports/sites/download?${queryString}`))
}

export const getSpeciesForDownload = (queryString) => {
  return fetchDownloadChunks(getApiUrl(`/api/reports/site-species/download?${queryString}`))
}

